var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[`${_vm.$appPrefix}-haendlersuche__map`]},[_c('div',{ref:"mapContainer",class:[`${_vm.$appPrefix}-haendlersuche__map-container`, _vm.selectedHaendler ? `${_vm.$appPrefix}-haendlersuche__map-container--selected-haendler` : '']})])
}
var staticRenderFns = []

export { render, staticRenderFns }